import defaultClient from '@src/api/clients/default';

export function fetchClientTerritories(clientId) {
  return defaultClient.request({
    url: 'dashboard/client-territories/',
    options: { params: { client_id: clientId } },
  });
}

// Territory labels selectable for a client's leads: configured territories
// (on or off) unioned with labels actually present on leads (incl. Out Of Area).
export function fetchLeadTerritoryOptions(clientId) {
  if (!clientId) {
    return Promise.resolve({ data: { territories: [] } });
  }
  return defaultClient.request({
    url: 'dashboard/leads/territory-options/',
    options: { params: { client_id: clientId } },
  });
}
